import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import t from '@zimpel/common/helpers/i18n';
import LoadingIndicator from '@zimpel/common/components/LoadingIndicator';
import * as api from '../api';
import useLanguageParam from '../useLanguageParam';
import OptOutPage from './OptOutPage';

enum Status {
  loading = 'loading',
  success = 'success',
  unknown = 'unknown',
}

const OptOutToken: React.FC = () => {
  const language = useLanguageParam();
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<Status>(Status.loading);
  const [isPrivateData, setIsPrivateData] = useState(false);

  useEffect(() => {
    if (token === undefined) {
      setStatus(Status.unknown);
      return;
    }
    (async () => {
      try {
        setIsPrivateData((await api.optOut({ token })).isPrivateSource);
        setStatus(Status.success);
      } catch {
        setStatus(Status.unknown);
      }
    })();
  }, [token]);

  if (status === Status.loading) {
    return <LoadingIndicator />;
  }

  return (
    <OptOutPage
      headline={t(`view.opt_out.header_${language}`)}
      message={status === Status.unknown
        ? t(`view.opt_out.token_unknown_${language}`)
        : t(`view.opt_out.unsubscribe_success_${language}`)}
      hint={isPrivateData ? t(`view.opt_out.private_data_hint_${language}`) : undefined}
      hintHeader={t(`view.opt_out.private_data_hint_header_${language}`)}
    />
  );
};

export default OptOutToken;
